export const getSubsectorsFromSectors = (includedSectorIds: string[], sectorList: any[]): string[] => {
  const subsectorIds: string[] = [];
  includedSectorIds.forEach((sectorId) => {
    const sector = sectorList.find((s) => s.sectorId === sectorId);
    sector?.subsectorList?.forEach((sub) => subsectorIds.push(sub.subsectorId));
  });
  return subsectorIds;
};
